
  import { defineComponent, ref, onMounted, computed } from 'vue';
  import { useRouter } from 'vue-router';
  import { setCurrentPageBreadcrumbs } from '@/core/helpers/breadcrumb';
  import { useI18n } from 'vue-i18n/index';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useAbility } from '@casl/vue';
  import Datatable from '@/components/kt-datatable/KTDatatable.vue';

  export default defineComponent({
    name: 'contacts-us-listing',
    components: {
      Datatable,
    },
    async setup() {
      const { t, te } = useI18n();
      const store = useStore();
      const router = useRouter();
      const { can } = useAbility();

      const translate = (text) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };

      onMounted(async () => {
        setCurrentPageBreadcrumbs(translate('contactUsListing'), [
          translate('settings'),
        ]);
        loading.value = true;

        await store.dispatch(Actions.GET_CONTACTS);
        loading.value = false;
      });

      const loading = ref(false);
      const tableHeader = ref([
        {
          name: translate('fullName'),
          key: 'fullname',
          sortable: true,
        },
        {
          name: translate('phoneNumber'),
          key: 'phone',
          sortable: false,
        },
        {
          name: translate('email'),
          key: 'email',
          sortable: true,
        },
        {
          name: translate('createdDate'),
          key: 'createdDate',
          sortable: true,
        },
        {
          name: translate('actions'),
          key: 'actions',
        },
      ]);

      const overViewContact = (id) => {
        router.push({ name: 'contact-us-overview', params: { id } });
      };

      const goTo = (pageName) => {
        router.push({ name: pageName });
      };

      const pageChanged = async (val) => {
        loading.value = true;
        await store.dispatch(Actions.UPDATE_CONTACT_CURRENT_PAGE, val);
        await store.dispatch(Actions.GET_CONTACTS);
        loading.value = false;
      };

      return {
        tableData: computed(() => store.getters.contactList),
        tableHeader,
        translate,
        totalItems: computed(() => store.getters.contactListCount),
        pageChanged,
        goTo,
        overViewContact,
        loading,
        can,
      };
    },
  });
